import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { FaTimes } from 'react-icons/fa';  // Import Font Awesome for cross icon
//import { faTimes } from '@fortawesome/free-solid-svg-icons';  // Import the specific icon you want to use

function SimpleFinderDelete(props) {
  const [modal, setModal] = useState(false);
  const {isLoading, reqLocId_delete, locationId, token} = props

  const toggle = () => setModal(!modal);

  const handleDelete = () => {
    // Call your delete API or function here
    //console.log('Delete button clicked');
    toggle();
    reqLocId_delete(locationId, token);
  };
 
  
   
  return (
    <div>
{/*       <Button color="danger" onClick={toggle}>
        Delete
      </Button> */}
    <button type="button" className="sf-btn--decor btn btn-outline-danger"
        onClick={toggle}
    >
        {isLoading && (
            <span className="spinner-border spinner-border-sm"></span>
        )}

        Delete
    </button>

      <Modal isOpen={modal} toggle={toggle}>
        {/* Custom close button with a cross icon */}
        <ModalHeader toggle={toggle} close={
          <button className="close" onClick={toggle} style={{ background: 'none', border: 'none' }}>
            <FaTimes />
          </button>
        }>
          Delete Confirmation
        </ModalHeader>
        <ModalBody>
          Are you sure you want to delete this item?
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={handleDelete}>
            Delete
          </Button>{' '}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default SimpleFinderDelete;
